<template>
    <q-btn
            label="View all notifications"
            no-caps
            v-bind="$attrs"
            @click="openModal" />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import openModal from '@/components/modal';
import NotificationsModal from '@/user-notification/NotificationsModal.vue';

export default defineComponent({
  props: {
    userId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal(): void {
      const props = { parent: this, userId: this.userId };
      openModal(NotificationsModal, props);
    },
  },
});
</script>
